import { document } from '../env/browser';

export const createScriptNode = (
  props: Record<string, unknown> = {}
): HTMLScriptElement => {
  const scriptNode = (document as unknown as Document).createElement('script');
  scriptNode.type = 'text/javascript';
  Object.assign(scriptNode, props);
  return scriptNode;
};

export const createAsyncScriptNode = (
  props: Record<string, unknown> = {}
): HTMLScriptElement => createScriptNode({ async: true, ...props });
